export const updateSuccessMessage = (message, callback) => {
  callback(message) // Set the success message
  setTimeout(() => callback(''), 2000) // Remove success message after 2 seconds
}

export default { updateSuccessMessage }
